/** Today's date (YYYY-MM-DD) in the family's time zone. */
export function todayIn(timeZone: string): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone }).format(new Date());
}

/** The day before a YYYY-MM-DD date. */
export function dayBefore(date: string): string {
  const d = new Date(`${date}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
}

/**
 * A YYYY-MM-DD day as people read it: "Today", "Yesterday", or a short date ("Mon, Oct 12").
 * The day is formatted at noon UTC so it never shifts across time zones.
 */
export function formatDay(
  date: string,
  today: string,
  locale: string | undefined,
  words: { today: string; yesterday: string },
): string {
  if (date === today) return words.today;
  if (date === dayBefore(today)) return words.yesterday;
  const sameYear = date.slice(0, 4) === today.slice(0, 4);
  return new Intl.DateTimeFormat(locale, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    ...(sameYear ? {} : { year: 'numeric' }),
    timeZone: 'UTC',
  }).format(new Date(`${date}T12:00:00Z`));
}
